import styled from 'styled-components';
import Card from 'components/Card';
import ChannelPicker from 'components/ChannelPicker';
import Input from 'components/Input';
import { DIVIDER, GREY_50 } from '../../constants';

export const Container = styled.div`
    height: calc(100vh - 161px);
    box-sizing: border-box;
    display: flex;
    gap: 1rem;
`;

export const LeftColumn = styled(Card)`
    box-sizing: border-box;
    display: flex;
    flex: 1;
    flex-direction: column;
    max-width: 24rem;
    padding: 0rem;
`;

export const Main = styled(Card)`
    box-sizing: border-box;
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const FiltersContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 1.5rem;
    padding: 1rem 0 0.5rem;
    gap: 1rem;
    border-bottom: 1px solid ${DIVIDER};
`;

export const StyledChannelPicker = styled(ChannelPicker)`
    & > div {
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        gap: 0.5rem;
        padding-bottom: 0.25rem;
        
        /* Small scrollbar styling */
        scrollbar-width: thin; /* Firefox */
        scrollbar-color: #e9ecef transparent; /* Firefox */
        
        &::-webkit-scrollbar {
            height: 3px;
        }
        
        &::-webkit-scrollbar-track {
            background: transparent;
        }
        
        &::-webkit-scrollbar-thumb {
            background: #e9ecef;
            border-radius: 1.5px;
        }
        
        &::-webkit-scrollbar-thumb:hover {
            background: #dee2e6;
        }
    }
`;

export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 1.5rem 1rem 0rem 1rem;
`;

export const Title = styled.h2`
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 800;
    line-height: 1.75rem;
    margin: 0;
`;

export const TitleActions = styled.div`
    display: flex;
    align-items: center;
    gap: 0.125rem;
`;

export const ThreadsLimitMessage = styled.div`
    padding: 0.5rem 1.5rem;
    font-size: 0.75rem;
    color: #adb5bd;
    position: relative;
    top: 0;
    width: 100%;
    height: 1.625rem;
    text-align: center;
    z-index: 1;

    &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        height: 1rem;
        background: linear-gradient(to bottom, white 0.25%, transparent 100%);
    }
`;

export const StyledSearchInput = styled(Input)`
    width: 100%;

    span {
        left: 1rem;
    }

    svg {
        width: 1.5rem !important;
        height: 1.5rem !important;
        font-size: 1.5rem !important;
    }

    input {
        background: ${GREY_50};
        border-color: ${GREY_50};
        height: 3rem;
        line-height: 3rem;
        padding: 0px 1rem 0px 3rem;
        font-weight: 300 !important;

        &:focus {
            padding-left: 2.9375rem;
        }

        ::placeholder {
            font-weight: 300 !important;
        }
    }
`;
export const ThreadsListContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
`;

export const NoConversationSelected = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 2rem;
    margin-bottom: 2rem;
    gap: 1rem;
`;

export const NoConversationIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #f8f9fa;
    color: #6c757d;
    margin-bottom: 0.5rem;

    svg {
        width: 48px;
        height: 48px;
    }
`;

export const NoConversationTitle = styled.h3`
    font-size: 1.5rem;
    font-weight: 600;
    color: #212529;
    margin: 0;
    text-align: center;
`;

export const NoConversationDescription = styled.p`
    font-size: 1rem;
    color: #6c757d;
    text-align: center;
    max-width: 60%;
    margin: 0;
    margin-top: -0.5rem;
    line-height: 1.5;
`;
